import request from '@/utils/request'

const baseUrl = '/erp/sales/report/product-sales-summary'

export const pageProductSalesSummaryReport = params => request({
  url: baseUrl + '/page',
  method: 'get',
  params
})

export const exportProductSalesSummaryReport = params => request({
  url: baseUrl + '/export',
  method: 'get',
  params,
  responseType: 'blob'
})
